export const environment = {
  production: false,
  BASE_URL: 'https://dev.op.acco.satsang.org.in/api/v1',
  COMMON_BASE_URL: 'https://dev.acco.satsang.org.in/api/v1',
  localhostUrl: '',
  CONFIG_KEY_1: 'db.requisition.window.open.regular.days',
  CONFIG_KEY_2: 'requisition.regular.window.max.night.value',
  SSO_URL: 'https://sso.test.satsang.org.in',
  activityLogoutTimeInMins: 980,
  timeBeforeCallingRefreshInSecs: 840
};
